import NfpLogo from "../assets/nfp-logo.svg";

export const FALLBACK_PROJECT_IMAGE =
  "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=60";

export const PROJECT_CATEGORIES = [
  "All",
  "FinTech & Banking",
  "Mobile Apps",
  "Enterprise & Web",
];

export const PROJECTS_DATA = [
  {
    title: "NFP (National Fraud Portal) – PayNet",
    category: "FinTech & Banking",
    description:
      "Integrated portal launched with Bank Negara Malaysia (BNM) and financial institutions to streamline scam reporting and rapidly trace/freeze stolen funds; supports NSRC operations and standardized mule account data sharing.",
    image: NfpLogo,
    tech: [
      "Nuxt 3",
      "Tailwind CSS",
      "daisyUI",
      "Zod",
      "TypeScript",
      "Vitest",
      "Pinia",
      "Java",
      "Spring Boot",
    ],
    demo: "#",
    code: "#",
  },
  {
    title: "UMeetMe Video Conferencing",
    category: "Enterprise & Web",
    description:
      "Secure video conferencing for Telkom Indonesia featuring Jitsi SDK, multi-participant video calls, real-time chat, screen sharing, and Spring Boot backend integration.",
    image: "https://logo.clearbit.com/telkom.co.id",
    tech: ["React Native", "React JS", "Jitsi SDK", "Spring Boot", "WebSocket", "SQL"],
    demo: "#",
    code: "#",
  },
  {
    title: "SMMF Multi-Finance Management",
    category: "FinTech & Banking",
    description:
      "Multi-Finance management mobile app with React Native, Context API, TypeScript, Jest testing, Zodios, and atomic design pattern.",
    image: "https://logo.clearbit.com/simasfinance.co.id",
    tech: ["React Native", "TypeScript", "React Context", "Jest", "Zodios", "Atomic Design"],
    demo: "#",
    code: "#",
  },
  {
    title: "Pasardana Stock Trading & Monitor",
    category: "FinTech & Banking",
    description:
      "Real-time stock market monitoring and trading application featuring real-time stock prices, candlestick charts, market news, price alerts, and watchlists.",
    image: "https://logo.clearbit.com/pasardana.id",
    tech: ["React Native", "TypeScript", "Redux", "Redux-Saga", "Axios", "Financial Charts"],
    demo: "#",
    code: "#",
  },
  {
    title: "Leapsy Language Learning",
    category: "Mobile Apps",
    description:
      "Language learning mobile app built with React Native, Redux, and TypeScript featuring smooth micro-animations and interactive vocabulary quizzes.",
    image: "https://cdn.prod.website-files.com/6617d53bc2cdae351819c8c9/66449a6eb524eaf1bd8f471f_logo-leapsy.svg",
    tech: ["React Native", "Redux", "TypeScript", "Mobile Animations", "Education"],
    demo: "#",
    code: "#",
  },
  {
    title: "SRC Retail Operations (AturToko)",
    category: "Mobile Apps",
    description:
      "Retail operations app for Sampoerna store network: real-time inventory management, sales analytics dashboard, loyalty programs, and targeted push promos.",
    image: "https://logo.clearbit.com/src.id",
    tech: ["React Native", "Redux", "Redux-Saga", "Retail Analytics", "Push Notifications"],
    demo: "#",
    code: "#",
  },
  {
    title: "Pruforce (Prudential)",
    category: "FinTech & Banking",
    description:
      "Enterprise mobile app built for Prudential insurance agents and field operations.",
    image: "https://logo.clearbit.com/prudential.co.id",
    tech: ["React Native", "React", "Redux", "Enterprise Insurance"],
    demo: "#",
    code: "#",
  },
  {
    title: "IndoHUB Traffic & CCTV Monitor",
    category: "Mobile Apps",
    description:
      "Real-time CCTV road traffic monitoring for Bandung city with live camera streams, traffic congestion alerts, road closure notifications, and map view.",
    image: "https://images.unsplash.com/photo-1585432959449-98c3b0a93f0a?auto=format&fit=crop&w=1200&q=60",
    tech: ["React Native", "Redux-Saga", "Live CCTV Streaming", "Map Location"],
    demo: "#",
    code: "#",
  },
  {
    title: "Santooi Wellness & Yoga",
    category: "Mobile Apps",
    description:
      "Guided self-meditation, mindfulness, self-healing, and yoga mobile application with custom audio players and streak dashboards.",
    image: "https://images.unsplash.com/photo-1519181245277-cffeb31da2a5?auto=format&fit=crop&w=1200&q=60",
    tech: ["React Native", "Redux-Saga", "Audio Streaming", "Wellness"],
    demo: "#",
    code: "#",
  },
  {
    title: "Broko Mobile Platform",
    category: "Mobile Apps",
    description: "Mobile product application platform.",
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=1200&q=60",
    tech: ["React Native", "Mobile"],
    demo: "#",
    code: "#",
  },
  {
    title: "PGN LNG Corporate Website",
    category: "Enterprise & Web",
    description: "Official corporate web platform for PGN LNG.",
    image: "https://logo.clearbit.com/pgnlng.co.id",
    tech: ["Web", "React", "Tailwind CSS"],
    demo: "#",
    code: "#",
  },
  {
    title: "KAI Recruitment Portal",
    category: "Enterprise & Web",
    description: "Enterprise recruitment and job application portal for Kereta Api Indonesia (KAI).",
    image: "https://logo.clearbit.com/kai.id",
    tech: ["Web", "Recruitment", "SQL"],
    demo: "#",
    code: "#",
  },
];
